import React from "react"

export default function Crown() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path d="M15.2498 13.7256L14.9748 14.9175C14.9185 15.1606 14.7021 15.3327 14.4527 15.3327H3.73854C3.48908 15.3327 3.27265 15.1606 3.2164 14.9175L2.94141 13.7256H15.2498Z" fill="#5B5E71" />
      <path d="M16.583 7.95336L15.4982 12.6542H2.69522L1.61042 7.95336C1.56256 7.74586 1.64203 7.52979 1.81292 7.40283C1.98416 7.27569 2.21398 7.26266 2.39826 7.36783L5.71393 9.26245L8.65085 4.85734C8.74638 4.71394 8.90477 4.62537 9.07691 4.61912C9.25066 4.6118 9.41387 4.69002 9.51958 4.82573L12.9638 9.25388L15.7638 7.3873C15.9466 7.26623 16.1848 7.26748 16.3654 7.3923C16.5461 7.51676 16.6322 7.73943 16.583 7.95336Z" fill="#5B5E71" />
    </svg>
  )
}
